// @ts-ignore
import type {OutputSelector} from 'reselect';
import {Collections} from '../collections';
import type {CollectionState} from '../collections';
import type {AccountType} from './account-types-types';

type AccountTypesModuleState = {
    accountTypes: CollectionState<AccountType>;
};

/*
 * Given the entire redux state, pull out just the piece of state for the accountTypes reducer.
 */
const getAccountTypesState = (state: AccountTypesModuleState) => state.accountTypes;

/*
 * Get an array of all accountTypes models
 */
export const getAll: OutputSelector<any, any, AccountType[]> =
    Collections.makeGetModels(getAccountTypesState);

/*
 * Get the `byId` portion of the accountTypes state
 */
export const getById = (state: AccountTypesModuleState) => {
    const accountTypesState = getAccountTypesState(state);

    return Collections.getById(accountTypesState);
};
